export default {
  meta: {
    title: '一鸣'
  }
};
